/* eslint-disable */

import type { SalaryLang } from "./types/SalaryLang";

let data: SalaryLang | undefined;

export type { SalaryLang };

export default function SalaryLangFactory(): SalaryLang {
  if (!data) {
    throw new Error("Trying to load a language in the main bundle before the language bundle is loaded");
  }
  return data;
}

export let setSalaryLang = (newLang: string) => {
  if (newLang === "en-GB") {
      return import(/* webpackChunkName: "en-GB.locale" */ "./en-GB/SalaryLangDef").then(({ SalaryLangDef }) => {
      data = SalaryLangDef;
    });
  } else if (newLang === "sv-SE") {
      return import(/* webpackChunkName: "sv-SE.locale" */ "./sv-SE/SalaryLangDef").then(({ SalaryLangDef }) => {
      data = SalaryLangDef;
    });
  } else if (newLang === "en-SE") {
      return import(/* webpackChunkName: "en-SE.locale" */ "./en-SE/SalaryLangDef").then(({ SalaryLangDef }) => {
      data = SalaryLangDef;
    });
  } else if (newLang === "ky-KG") {
      return import(/* webpackChunkName: "ky-KG.locale" */ "./ky-KG/SalaryLangDef").then(({ SalaryLangDef }) => {
      data = SalaryLangDef;
    });
  }
  else {
    throw new Error("Unsupported language/culture " + newLang);
  }
};

